import authApi from '~/authApi';

import { makeApiClient } from './client';

export const searchApi = makeApiClient(
  `${process.env.NEXT_PUBLIC_SEARCH_RESOURCE}/v1`,
  {},
  (req) => {
    const { jwtAccessToken } = authApi;

    if (jwtAccessToken) {
      req.headers['X-AUTH-TOKEN'] = jwtAccessToken.accessToken;
    }
    return req;
  },
);
